import { locationMapping } from "../../../utils/constant";
import { filterAnalyticsLocationsByOrg } from "../../../utils/helpers";

export async function getAllCompetetionTrends(payload, thunkApi) {
  try {
    const { product } = thunkApi.extra.apiService;
    const { source, selectedCategories, domesticPlayers, organizationId } =
      payload;
    
    // Use provided domestic players or fallback to all domestic locations
    const domesticLocation = domesticPlayers || Object.keys(locationMapping).filter((item) => {
      if (locationMapping[item].type !== "Duty Free") {
        return item;
      }
    });
    
    const allDutyFree = Object.keys(locationMapping).filter((item) => {
      if (locationMapping[item].type === "Duty Free") {
        return item;
      }
    });
    // Lagardere (org 3): Auckland, Melbourne, Sydney, Changi only
    const dutyFreeLocation = filterAnalyticsLocationsByOrg(
      allDutyFree,
      organizationId
    );
    
    // Debug logging
    console.log('Analytics API - Source:', source);
    console.log('Analytics API - Domestic players:', domesticLocation);
    console.log('Analytics API - Duty-free locations:', dutyFreeLocation);

    let duty_free = await product.get(
      "?source=" +
        source +
        "&location=" +
        dutyFreeLocation.join(",")?.toLowerCase() +
        "&category=" +
        selectedCategories.join(",")?.toLowerCase()
    );
    let domestic = await product.get(
      "?source=" +
        source +
        "&location=" +
        domesticLocation.join(",")?.toLowerCase() +
        "," +
        source +
        "&category=" +
        selectedCategories.join(",")?.toLowerCase()
    );

    // 1) Merge the two location lists once
    const allLocations = [...dutyFreeLocation, ...domesticLocation];

    // 2) Build one request per location (runs in parallel)
    const entries = await Promise.all(
      allLocations.map(async (item) => {
        // Build the query string safely
        const params = new URLSearchParams({
          source,
          location: `${item},${source}`,
          category: selectedCategories.join(",").toLowerCase(),
        }).toString();

        // Axios-style GET: product.get returns { data } by convention
        const data = await product.get(`?${params}`);

        // Return a tuple [key, value] for Object.fromEntries
        return [item, data];
      })
    );
    const tempDataResult = Object.fromEntries(entries);

    let data = {
      typeComparision: [
        {
          website_type: "duty-free",
          product_count: duty_free?.stats?.productCount,
          cheapest_count: duty_free?.stats?.cheapestProducts,
          expensive_count: duty_free?.stats?.expensiveProducts,
          midrange_count: duty_free?.stats?.midrangeProducts,
        },
        {
          website_type: "domestic",
          product_count: domestic?.stats?.productCount,
          cheapest_count: domestic?.stats?.cheapestProducts,
          expensive_count: domestic?.stats?.expensiveProducts,
          midrange_count: domestic?.stats?.midrangeProducts,
        },
      ],
    };
    const buildComparison = (locations) =>
      locations.map((loc) => {
        // fall‑backs if the request failed or stats are missing
        const { stats = {} } = tempDataResult[loc] ?? {};

        return {
          website: loc, // "lotte_melbourne", …
          product_count: stats.productCount ?? 0,
          cheapest_count: stats.cheapestProducts ?? 0,
          expensive_count: stats.expensiveProducts ?? 0,
          midrange_count: stats.midrangeProducts ?? 0,
        };
      });
    // duty‑free list
    data.dutyFreeLocationComparision = buildComparison(dutyFreeLocation);

    // if you want the domestic list too:
    data.domesticLocationComparison = buildComparison(domesticLocation);

    return data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getAllTimeTrends(payload, thunkApi) {
  try {
    const { analytics } = thunkApi.extra.apiService;
    const { source, latest_date, past_date } = payload;
    const response = await analytics.get(
      `/trend/time?source=${source}&latest_date=${latest_date}&past_date=${past_date}`
    );

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
export async function getAllPPCTrends(payload, thunkApi) {
  try {
    const { product } = thunkApi.extra.apiService;
    const { selectedLocations, source } = payload;
    const response = await product.get("/", {
      params: {
        location: selectedLocations.join(",") + "," + source,
        source,
      },
    });

    return response.category_stats;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getAllPPBTrends(payload, thunkApi) {
  try {
    const { product } = thunkApi.extra.apiService;
    const { source, selectedLocations } = payload;
    const response = await product.get("/", {
      params: {
        location: selectedLocations.join(",") + "," + source,
        source,
      },
    });

    return response.brand_stats;
  } catch (error) {
    return Promise.reject(error);
  }
}
